export enum Gender {
  male = "male",
  female = "female",
}

export const genderOptions = [
  {
    label: "Nam",
    value: `${Gender.male}|Nam`,
  },
  {
    label: "Nữ",
    value: `${Gender.female}|Nữ`,
  },
];
